var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-app-bar',{staticClass:"hidden-sm-and-down",attrs:{"clipped-left":"","app":"","dark":"","dense":"","color":"bluePcm"}},[_c('ClientNameAppbar'),_c('AppBarDefault')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }